import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Input, TextInput, Grid, Flex, Group, Stack } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import 'dayjs/locale/pt-br'
import React from 'react'
import { 
    handleMascaraProcessoProtocolo
} from '../../../utils/mascara'

const FiltroLicencaDispensa = ({ form, handleFilter, clearFilter }) => {
    const handleMascaraChange = (campo, valor) => {
        const DIGITOS_ANTES_BARRA = campo === 'numeroDocumento' ? 6 : 7;
        const DIGITOS_DEPOIS_BARRA = 4;
        const valorComMascara = handleMascaraProcessoProtocolo(valor, DIGITOS_ANTES_BARRA, DIGITOS_DEPOIS_BARRA)
        form.setFieldValue(campo, valorComMascara)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleFilter()
        }
    }

    return (
        <Stack onKeyDown={handleKeyDown}>
            <Grid mb="md">
                <Grid.Col span={12}>
                    <Flex
                        direction={{ base: 'column', sm: 'row' }}
                        gap="sm"
                        align={{ base: 'stretch', sm: 'flex-end' }}
                    >
                        <Input
                            {...form.getInputProps('cpfCnpjNome')}
                            style={{ flexGrow: 1, marginTop: '0.4rem' }}
                            placeholder="Pesquise por nome/razão social ou CPF/CNPJ"
                            rightSectionPointerEvents="all"
                            rightSection={
                                <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
                            }
                        />
                        <Group spacing="xs">
                            <Button
                                color="green"
                                fw={'lighter'}
                                radius={'xl'}
                                onClick={handleFilter}
                            >
                                Aplicar filtros
                            </Button>
                            <Button
                                color="green"
                                variant="subtle"
                                fw={'lighter'}
                                radius={'xl'}
                                onClick={clearFilter}
                            >
                                Limpar
                            </Button>
                        </Group>
                    </Flex>
                </Grid.Col>
            </Grid>

            <Grid mb="md">
                <Grid.Col span={4}>
                    <TextInput
                        label={"Número Documento:"}
                        placeholder="000000/0000"
                        value={form.values.numeroDocumento || ''}
                        onChange={(event) => handleMascaraChange('numeroDocumento', event.target.value)}
                        error={form.errors.numeroDocumento}
                        maxLength={12}
                    />
                </Grid.Col>
                <Grid.Col span={4}>
                    <TextInput
                        label={"Número Processo:"}
                        placeholder="0000000/0000"
                        value={form.values.numeroProcesso || ''}
                        onChange={(event) => handleMascaraChange('numeroProcesso', event.target.value)}
                        error={form.errors.numeroProcesso}
                        maxLength={12}
                    />
                </Grid.Col>
                <Grid.Col span={4}>
                    <TextInput
                        label={"Número Protocolo:"}
                        placeholder="0000000/0000"
                        value={form.values.numeroProtocolo || ''}
                        onChange={(event) => handleMascaraChange('numeroProtocolo', event.target.value)}
                        error={form.errors.numeroProtocolo}
                        maxLength={12}
                    />
                </Grid.Col>
            </Grid>

            <Grid mb="md">
                <Grid.Col span={4}>
                    <TextInput
                        {...form.getInputProps('municipio')}
                        label={"Município:"}
                    />
                </Grid.Col>
                <Grid.Col span={2}>
                    <DateInput
                        {...form.getInputProps('dataInicio')}
                        label={"Período Inicial:"}
                        placeholder={'DD/MM/AAAA'}
                        size="sm"
                        maxLength={10}
                        dateParser={value => {
                          const data = value.replace(/\D/g, '')
                          if (data.length !== 8) {
                            return null
                          }
                          const dia = Number(data.slice(0, 2))
                          const mes = Number(data.slice(2, 4)) - 1
                          const ano = Number(data.slice(4, 8))
                          if (
                            typeof dia === 'number' &&
                            typeof mes === 'number' &&
                            typeof ano === 'number'
                          ) {
                            return new Date(ano, mes, dia)
                          }
                          return null
                        }}
                        maxDate={new Date()}
                        valueFormat="DD/MM/YYYY"
                        locale="pt-br"
                        onKeyDown={e => {
                          const input = e.target
                          const value = input.value
                          const length = value.length
                          const key = e.key
                          const nextCharIsNumber = /\d/.test(key)
                          if (
                            nextCharIsNumber &&
                            (length === 2 || length === 5) &&
                            value[length - 1] !== '/'
                          ) {
                            input.value = value + '/' + e.key
                            e.preventDefault()
                          }
                        }}
                        clearable
                    />
                </Grid.Col>
                <Grid.Col span={2}>
                    <DateInput
                        {...form.getInputProps('dataFinal')}
                        label={"Período Final:"}
                        placeholder={'DD/MM/AAAA'}
                        size="sm"
                        maxLength={10}
                        dateParser={value => {
                          const data = value.replace(/\D/g, '')
                          if (data.length !== 8) {
                            return null
                          }
                          const dia = Number(data.slice(0, 2))
                          const mes = Number(data.slice(2, 4)) - 1
                          const ano = Number(data.slice(4, 8))
                          if (
                            typeof dia === 'number' &&
                            typeof mes === 'number' &&
                            typeof ano === 'number'
                          ) {
                            return new Date(ano, mes, dia)
                          }
                          return null
                        }}
                        maxDate={new Date()}
                        valueFormat="DD/MM/YYYY"
                        locale="pt-br"
                        onKeyDown={e => {
                          const input = e.target
                          const value = input.value
                          const length = value.length
                          const key = e.key
                          const nextCharIsNumber = /\d/.test(key)
                          if (
                            nextCharIsNumber &&
                            (length === 2 || length === 5) &&
                            value[length - 1] !== '/'
                          ) {
                            input.value = value + '/' + e.key
                            e.preventDefault()
                          }
                        }}
                        clearable
                    />
                </Grid.Col>
            </Grid>
        </Stack>
    )
}

export default FiltroLicencaDispensa
